import { initializeApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBXXpUb5o3sMur3-dfjuLBlD2kkyvcsXJI",
  authDomain: "fuse-53e16.firebaseapp.com",
  projectId: "fuse-53e16",
  storageBucket: "fuse-53e16.firebasestorage.app",
  messagingSenderId: "780292721077",
  appId: "1:780292721077:web:8f834d7eaae62759eb71fc",
  measurementId: "G-TY1CFP6655",
};

let messaging;
try {
  // Initialize Firebase
  const app = initializeApp(firebaseConfig);
  messaging = getMessaging(app);
} catch (e) {
  console.error(e);
}

export default messaging;
